import { render, staticRenderFns } from "./PaymentTypeDetailsContainer.vue?vue&type=template&id=0f3b6d55"
import script from "./PaymentTypeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./PaymentTypeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports